import moment from "moment"

export const dateToServerString = (date, format = 'YYYY-MM-DD') => {
    const mDate = moment(date)
    if (date && mDate.isValid()) {
      return mDate.format(format)
    } else {
      return null
    }
  }